import React from "react";
import DatePicker from "controls/DatePicker";
import SingleInput from "./SingleInput";

function DateInputDialogContent({ item, itemSet }) {
  const selectedDate = item
    ? (() => {
        const [y, m, d] = item.split("-").map(Number);
        return new Date(y, m - 1, d);
      })()
    : null;

  return (
    <DatePicker
      inline
      selected={selectedDate}
      onChange={(date) =>
        itemSet(
          date
            ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`
            : null,
        )
      }
    />
  );
}

function DateInputLabel({ item }) {
  if (!item) return null;
  const [y, m, d] = item.split("-").map(Number);
  return <>{new Date(y, m - 1, d).toLocaleDateString("zh-CN")}</>;
}

export default function DateInput({ ...others }) {
  return (
    <SingleInput
      {...others}
      itemDialogCompact
      renderItemDialogContent={DateInputDialogContent}
      renderItemLabel={DateInputLabel}
    />
  );
}
